"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "stringNotEmpty", {
    enumerable: true,
    get: function() {
        return stringNotEmpty;
    }
});
const stringNotEmpty = (v)=>v != null && v.trim().length > 0;

//# sourceMappingURL=stringNotEmpty.js.map